import { Box, Paper, PaperProps } from '@mui/material';
import { ReactNode } from 'react';

import { SolaForceHeading } from '~/components/SolaForceHeading';
import { useSxStyles } from '~/scenes/PortalModules/Analytics/common/ReportViewLayout/useStyles';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';
import { mergeSxProps } from '~/utils/helpers/sxProps';

type PropsType = {
  heading: string;
  isLoading?: boolean;
  slots?: {
    toolbar?: {
      main?: ReactNode;
      actions?: ReactNode;
    };
  };
  slotProps?: {
    content?: PaperProps;
  };
  children?: ReactNode;
};

export const ReportViewLayout = (props: PropsType) => {
  const { heading, isLoading, slots, children, slotProps } = props;

  const sxStyles = useSxStyles();

  return (
    <Box
      sx={mergeSxProps(
        sxStyles.root,
        !!children ? sxStyles.rootHasChildren : undefined,
      )}
    >
      <SolaForceHeading
        heading={heading}
        slotProps={{ root: { sx: sxStyles.heading } }}
      />
      {!!isLoading ? (
        <LoadingView />
      ) : (
        <>
          {!!slots?.toolbar && (
            <Paper sx={sxStyles.toolbar}>
              <Box sx={sxStyles.toolbarMain}>{slots.toolbar.main}</Box>
              {!!slots.toolbar.actions ? (
                <Box sx={sxStyles.toolbarActions}>{slots.toolbar.actions}</Box>
              ) : null}
            </Paper>
          )}
          {!!children && (
            <Box sx={sxStyles.contentWrapper}>
              <Paper
                {...slotProps?.content}
                sx={mergeSxProps(sxStyles.content, slotProps?.content?.sx)}
              >
                {children}
              </Paper>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};
